import React from 'react';
import PropTypes from 'prop-types';
import formatPrice from './priceFormatter'
import ColumnEditable from './ColumnEditable'
import AutocompleteTextInput from '../../../common/AutocompleteTextInput'
import Assets from '../../../../Assets';
import TypingTester from '@lib/TypingTester'
import Warning from '../../../common/Warning';
import ValueFormatter from '../../../utils/ValueFormatter';

export default class PricingTableRow extends React.Component {

    static propTypes = {
        columns: PropTypes.array.isRequired,
        row: PropTypes.object.isRequired,
        onChange: PropTypes.func
    }

    percentageColumns = ['Discount', 'MarginPercentage']
    withPriceSymbolColumn = ['Final', 'Margin']
    priceColumns = ['FactoryCost', 'TotalFactoryCost', 'Price', 'TotalPrice']

    constructor(props) {
        super(props)
        this.inputRef = React.createRef()
        this.tester = new TypingTester(250)
    }

    static defaultProps = {
        onChange: () => {
        }
    }

    state = {
        busy: false,
        focus: true,
        moduleOptions: [],
        descriptionOptions: [],
    }

    rowHasFocus = () => {
        return this.props.index == this.props.selectedRowId;
    }

    render() {
        let classes = [];
        if (this.state.busy) {
            classes.push('loading');
        }
        if (this.props.row.isRemoved) {
            classes.push('is-removed');
        }

        return (
            <tr key={`${this.props.row.id}`} className={classes.join(' ')}>
                {this.renderDataCell({
                    slug: 'Position',
                    value: this.props.index + 1
                })}
                {this.props.columns.map(column => (
                    this.renderDataCell(column)
                ))}
                {this.props.canAddAndEditRows && this.renderActions()}
            </tr>
        )
    }

    renderActions() {
        const icon = this.props.row.isRemoved ? Assets.visibleOnIcon : Assets.visibleOffIcon;
        const removeTitle = this.props.row.isRemoved ? __('Click to include to pricing, cost and technical documentation') : __('Click to exclude from pricing, cost and technical documentation');
        return (
            <td className="actions">
                <img title={removeTitle} style={{marginTop: "5px"}} src={icon} onClick={this.onRemoveActionClick}/>
            </td>
        )
    }

    onRemoveActionClick = () => {
        this.onChange('IsRemoved', !this.props.row.isRemoved, false);
    }

    onColumnChange(e, column) {
        if (this.isColumnNumeric(column)) {
            if (e.value !== '-') {
                e.value = ValueFormatter.decimal(e.value, this.props.row[_.camelCase(column.slug)]);
                if (isNaN(e.value)) {
                    e.value = this.props.row[_.camelCase(column.slug)];
                }
            }
        }

        let focus = column.slug === 'Block' ? true : this.state.focus;
        this.onChange(column.slug, e.value, focus);
    }

    onChange(propertyName, value, focus) {
        let onStart = (func) => this.setState({busy: true}, () => func());
        let onStop = () => this.setState({busy: false});

        this.props.onChange(propertyName, value, focus, onStart, onStop)
    }

    rendenAddModuleList = (option) => {
        return (
            <React.Fragment>
                <div>{option.moduleNumber}</div>
                <div className="pricing-input-module-description">{option.description}</div>
            </React.Fragment>
        );
    }

    renderModuleNumberAutoComplete(column, value) {
        let options = this.state.moduleOptions;
        return (
            <div className={this.state.moduleNumberBusy ? 'loading' : ''}>
                <AutocompleteTextInput
                    disabled={column.disabled || this.state.busy}
                    placeholder={__('')}
                    value={value || ''}
                    options={options}
                    onChange={this.onModuleNumberChange}
                    onEnter={this.loadPricingWithNewComponent}
                    onOptionClick={this.loadPricingWithNewComponent}
                    inputClassName="configurator-pricing-input"
                    hostElement={this.props.editorStepPricing}
                    renderOptionFunc={this.rendenAddModuleList}
                />
            </div>
        );
    }

    renderDescriptionAutoComplete(column, value) {
        let options = this.state.descriptionOptions;
        return (
            <div className={this.state.descriptionBusy ? 'loading' : ''}>
                <AutocompleteTextInput
                    disabled={column.disabled || this.state.busy}
                    placeholder={__('')}
                    value={value || ''}
                    options={options}
                    onChange={this.onDescriptionChange}
                    onEnter={this.loadPricingWithNewComponent}
                    onOptionClick={this.loadPricingWithNewComponent}
                    inputClassName="configurator-pricing-input"
                    hostElement={this.props.editorStepPricing}
                    renderOptionFunc={this.rendenAddModuleList}
                />
            </div>

        );
    }

    renderEditableColumn(column, value) {
        if (column.slug === "ModuleNumber")
            return this.renderModuleNumberAutoComplete(column, value);

        if (column.slug === "Description")
            return this.renderDescriptionAutoComplete(column, value);

        let attrs = {};
        if (this.isColumnNumeric(column)) {
            attrs.pattern = "[-1-9]+([,\.][0-9]+)?";
        }

        return (

            <React.Fragment>
                <input
                    ref={this.inputRef}
                    className="configurator-pricing-input"
                    type="text"
                    value={value}
                    column={column}
                    onFocus={(e) => {
                        this.setState({focus: true})
                    }}
                    disabled={column.disabled || this.state.busy}
                    onBlur={(e) => {
                        const target = e.target
                        this.setState({focus: false}, (next) => {
                            this.onColumnChange(target, column)
                        });
                    }}
                    onChange={e => this.onColumnChange(e.target, column)}
                    {...attrs}
                />
                {this.valueWithUnits('', column.slug)}
            </React.Fragment>
        )
    }

    isReadOnly = () => this.props.columns.find(x => x.slug === 'ModuleNumber').readonly;

    labelClick = (column) => {
        if (this.isReadOnly()) {
            return;
        }

        this.props.setActiveRow(this.props.index)
    }

    renderDataCell = (column, editable) => {
        let checkboxId = Math.floor(Math.random() * 1000) + '_' + column.slug
        let value = this.getColumnValue(column)
        
        return (
            <td key={column.slug} className={`column-${column.slug}` + this.getNoWrapClass(column.slug)}
                onClick={() => this.labelClick(column.slug)}>
                {column.slug === 'Position' ? (
                    <span>
                        {this.props.row.isRemoved && (this.createWarning())}
                        {this.props.row.isFromModel || this.isReadOnly() ? (
                            <span>{value}.</span>
                        ) : (
                            <div className="flex-center-v flex-space-between w-100">
                                    <span>
                                        <input id={checkboxId} type="checkbox"
                                               checked={this.props.row.isSelected || false}
                                               onChange={this.props.onCheckboxChange}/>
                                        <label htmlFor={checkboxId}></label>
                                    </span>
                                <span>{value}.</span>
                            </div>
                        )}
                    </span>
                ) : (
                    this.isColumnEditable(column) && this.rowHasFocus() ? this.renderEditableColumn(column, value) : this.renderValueColumn(column, value)

                )}
            </td>
        )
    }

    createWarning() {
        return (
            <div style={{position: 'absolute', left: '10px', top: '10px'}}>
                <Warning warning={{
                    color: 'gray',
                    text: __('Module excluded from pricing, cost and technical documentation!')
                }}/>
            </div>
        )
    }

    renderValueColumn(column, value) {
        let priceColumns = this.priceColumns;
        return (

            <React.Fragment>
                {priceColumns.includes(column.slug) ? (formatPrice(value) + ` €`) : this.valueWithUnits((value), column.slug)}
            </React.Fragment>
        )

    }

    getNoWrapClass(slug) {
        let columns = [...this.percentageColumns, ...this.withPriceSymbolColumn, ...this.priceColumns];
        if (columns.includes(slug))
            return ' no-wrap'
        return '';
    }

    valueWithUnits(value, columnSlug) {
        if (this.percentageColumns.includes(columnSlug))
            return value + ' %';

        if (this.priceColumns.includes(columnSlug) || this.withPriceSymbolColumn.includes(columnSlug))
            return value + ' €';

        return value;

    }

    /**
     * Get value of specified column from given row.
     *
     * @param {Object} column
     * @param {Object} row
     * @return {any}
     */
    getColumnValue = (column, row = this.props.row) => {
        for (let [k, v] of Object.entries(row)) {
            if (k.toLowerCase() === column.slug.toLowerCase()) {
                return v
            }
        }

        return column.value;
    }

    /**
     * Returns whether specified column should be editable by the user.
     *
     * @param {Object} column
     * @return {Boolean}
     */
    isColumnEditable = column => {
        return ColumnEditable.isEditable(this.props.row, column, this.props.canAddAndEditRows);
    }

    isColumnNumeric(column) {
        return [
            'quantity',
            'factorycost',
            'price'
        ].includes(column.slug.toLowerCase())
    }

    onModuleNumberChange = value => {
        this.props.onChange('ModuleNumber', value, true);

        this.tester.record(() => {
            this.setState({
                moduleNumberBusy: true
            }, () => {
                if (value) {
                    this.props.getModulesByModuleNumber(value, data => {
                        this.setState({
                            moduleOptions: data,
                            moduleNumberBusy: false
                        })
                    })
                } else {
                    this.setState({
                        moduleOptions: [],
                        moduleNumberBusy: false
                    })
                }
            })
        });
    }

    onDescriptionChange = value => {
        this.props.onChange('Description', value, true);
        this.tester.record(() => {
            this.setState({
                descriptionBusy: true
            }, () => {
                if (value) {
                    this.props.getModulesByDescription(value, data => {
                        this.setState({
                            descriptionOptions: data,
                            descriptionBusy: false
                        })
                    })
                } else {
                    this.setState({
                        descriptionOptions: [],
                        descriptionBusy: false
                    })
                }
            })

        })
    }

    loadPricingWithNewComponent = option => {
        var column = this.props.columns.filter(c => c.slug == "ModuleNumber")[0];

        let onStart = (func) => this.setState({busy: true}, () => func());
        let onStop = () => this.setState({busy: false});

        this.props.loadPricingWithNewComponent(this.props.row, column, option.id, onStart, onStop);
    }
}